import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-item" }
const _hoisted_4 = { class: "form-item" }
const _hoisted_5 = { class: "info-group" }
const _hoisted_6 = { class: "qr-panel" }
const _hoisted_7 = { class: "qr-header" }
const _hoisted_8 = { class: "qr-title" }
const _hoisted_9 = { class: "version-tag" }
const _hoisted_10 = { class: "qr-code" }
const _hoisted_11 = { class: "detail-row" }
const _hoisted_12 = { class: "detail-row" }
const _hoisted_13 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_14 = { class: "val" }
const _hoisted_15 = {
  key: 1,
  class: "detail-row"
}
const _hoisted_16 = { class: "val" }
const _hoisted_17 = {
  key: 2,
  class: "remark-card"
}
const _hoisted_18 = { class: "remark-header" }
const _hoisted_19 = { class: "remark-content" }
const _hoisted_20 = { class: "button-group" }
const _hoisted_21 = { class: "tiyan" }
const _hoisted_22 = { class: "demo-rich-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_vue_qr = _resolveComponent("vue-qr")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Iphone = _resolveComponent("Iphone")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { for: "visibility" }, "发布类型:", -1)),
          _createVNode(_component_el_select, {
            id: "visibility",
            modelValue: _ctx.option,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.option) = $event)),
            placeholder: "请选择发布阶段",
            style: {"width":"160px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "内测 (无需审核)",
                value: "内测"
              }),
              _createVNode(_component_el_option, {
                label: "公测 (需审核)",
                value: "公测"
              }),
              _createVNode(_component_el_option, {
                label: "正式上线 (需审核)",
                value: "正式上线"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("span", {
            class: _normalizeClass(["status-explain-badge", _ctx.optionClass])
          }, _toDisplayString(_ctx.optionExplain), 3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "price" }, "体验价格:", -1)),
          _createVNode(_component_el_input, {
            id: "price",
            modelValue: _ctx.defaultPrice,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.defaultPrice) = $event)),
            type: "number",
            placeholder: "0 为免费",
            style: {"width":"160px"}
          }, {
            append: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("元", -1)
            ]))]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_row, { gutter: 24 }, {
          default: _withCtx(() => [
            (_ctx.form.id != null)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  span: 11
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.currentVersionTitle), 1),
                        _createElementVNode("span", _hoisted_9, "v" + _toDisplayString(_ctx.form.version || 1) + ".0", 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_vue_qr, {
                          text: _ctx.qr_text,
                          size: 200
                        }, null, 8, ["text"])
                      ]),
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "qr-tip" }, "玩家使用移动端 App 扫码入局", -1))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, {
              span: 13,
              class: "info-details"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "当前阶段:", -1)),
                  _createElementVNode("span", {
                    class: _normalizeClass(["val phase-tag", _ctx.currentPhaseClass])
                  }, _toDisplayString(_ctx.currentPhaseLabel), 3)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "审核状态:", -1)),
                  _createElementVNode("span", {
                    class: _normalizeClass(["val status-tag", _ctx.statusTagClass])
                  }, _toDisplayString(_ctx.statusLabel), 3)
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "detail-row" }, [
                  _createElementVNode("span", { class: "label" }, "游玩区域:"),
                  _createElementVNode("span", { class: "val" }, "不限地点 / 开放探索")
                ], -1)),
                (_ctx.form.createTime)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "初次创建:", -1)),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.form.createTime), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.form.releaseTime)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "生效时间:", -1)),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.form.releaseTime), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.form.remark)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_WarningFilled)
                          ]),
                          _: 1
                        }),
                        _cache[10] || (_cache[10] = _createElementVNode("span", null, "审核意见/反馈备注", -1))
                      ]),
                      _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.form.remark), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_el_button, {
          type: "primary",
          class: "release-main-btn",
          loading: _ctx.publishing,
          onClick: _ctx.releaseGame
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.publishBtnText), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_el_popover, {
          width: 200,
          placement: "top",
          "popper-style": "box-shadow: 0 10px 30px rgba(15, 23, 42, 0.15); padding: 16px; border-radius: 12px;"
        }, {
          reference: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Iphone)
                ]),
                _: 1
              }),
              _cache[12] || (_cache[12] = _createElementVNode("span", null, "创作者即时体验通道", -1))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "demo-tip" }, "开发测试专用码", -1)),
              _createVNode(_component_vue_qr, {
                text: _ctx.qr_text2,
                size: 180
              }, null, 8, ["text"]),
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "demo-sub" }, "仅创作者测试设备可扫", -1))
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}